import type { UserAvatar } from '../../../api/people';
import { uiText } from '../../../i18n';
import type { PeopleData } from './use-people-data';

export interface Face {
  value: string;
  name: string;
  sub?: string;
  image?: string | null;
  icon?: string;
  /** у близкого нет фото: жёлтая точка, нажатие — «Добавьте фото» */
  needsPhoto?: boolean;
  disabled?: string;
}
export function selfFace(data: PeopleData, avatar: UserAvatar | null): Face & { ready: boolean } {
  const variant = data.self?.src === 'avatar' ? data.variants.find(item => String(item.id) === String(data.self?.pick)) ?? avatar : null;
  const ready = !!data.self?.ready || !!variant;
  return {
    value: 'me',
    name: uiText('Вы'),
    sub: variant ? variant.variant_name : undefined,
    image: variant?.image_url ?? data.self?.photos[0]?.url ?? null,
    needsPhoto: !ready,
    ready,
  };
}
